import React, { useContext } from "react";
import { Button, Modal, Space } from "antd";
import TableData from "./TableData";
import PlaceForm from "./PlaceForm";
import { context } from "../../context/context";

const PlaceTable = () => {
    const {
        isModalOpen,
        setIsModalOpen,
        setPlaceName,
        setPlaceIcon,
        setPlaceTag,
        setPlaceColor,
        setPlaceMapIcon,
        setIsEditShow,
        setIsAddSubset,
        setFileList,
    } = useContext(context);
    const handleModalOpen = () => {
        setIsModalOpen(true);
        setPlaceIcon("");
        setPlaceMapIcon("");
        setPlaceColor("#FFFFFF");
        setPlaceName("");
        setPlaceTag([]);
        setFileList([]);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
        setIsEditShow(false);
        setIsAddSubset(false);
        setFileList([]);
    };

    return (
        <>
            <Space direction="vertical" style={{ width: "100%" }} align="end">
                <Button onClick={handleModalOpen} type="primary" ali>
                    اضافه کردن دسته جدید
                </Button>
            </Space>
            <TableData />
            <Modal
                title={"اضافه کردن دسته جدید"}
                open={isModalOpen}
                onCancel={handleCancel}
                okButtonProps={{ hidden: "true" }}
                cancelButtonProps={{ hidden: "true" }}
            >
                <PlaceForm />
            </Modal>
        </>
    );
};

export default PlaceTable;
